<template>
  <div>
    <v-table :height="550"  is-horizontal-resize="" column-width-drag
             style="width:100%;"
             :columns="tableColumn" :table-data="subjectToBeProcessedData" row-hover-color="#edf7ff"
             :is-loading="modal_loading" title-bg-color="#f8f8f9" ></v-table>
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
  </div>
</template>
<script>
  var tableSubjectToBeProcessedVue = {}
  export default {
    name: 'TableSubjectToBeProcessed',
    components: {
    },
    data () {
      return {
        val:'',
        showList:[],
        dataTotal:0,
        lineIndex:0,
        subjectToBeProcessedName:'',
        isDisable: false,
        current:1,
        pageSize:10,
        modal_loading: false,
        tableColumn: [
          {
            field: 'emailSubject',
            title: this.$t('configuration_management.mailbox_management.emailSubject'),
            width: 180,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
        ],
        subjectToBeProcessedData: []
      }
    },
    beforeCreate: function() {
      tableSubjectToBeProcessedVue = this
    },
    mounted: function(){
      tableSubjectToBeProcessedVue.getSubjectToBeProcessedData();
    },
    methods: {
      showAll: function(){
        tableSubjectToBeProcessedVue.getSubjectToBeProcessedData();
      },
      doDelete: function(index){
        this.lineIndex=index;
        this.subjectToBeProcessedName=this.subjectToBeProcessedData[index].name;
      },
      getSubjectToBeProcessedData: function() {
        //获取查询内容
        eventBus.$on('subjectToBeProcessedSearchName',function(val){
          tableSubjectToBeProcessedVue.val=val;
        })
        tableSubjectToBeProcessedVue.$api.mailbox.pageSubjectToBeProcessed({
          "keyword":tableSubjectToBeProcessedVue.val,
          "pageNum":this.current,
          "pageSize":this.pageSize
        })
          .then(res => {
            if (res.data.records) {
              this.subjectToBeProcessedData = JSON.parse(JSON.stringify(res.data.records));
            }
            this.modal_loading = false;
            // 当前页
            this.current = res.data.current;
            // 总条数
            this.dataTotal = res.data.total;
          })
          .catch(err=>{
            if(err.status==404){
              this.modal_loading = false;
            }
          })
      },
      changePage: function(current){
        this.current=current;
        tableSubjectToBeProcessedVue.getSubjectToBeProcessedData();
      },
      changeSize: function(pageSize){
        this.pageSize=pageSize;
        tableSubjectToBeProcessedVue.getSubjectToBeProcessedData();
      },
      beforeDestroy: function(){
        eventBus.$off('subjectToBeProcessedSearchName');
      }
    }
  }
</script>
<style scoped>
  .ivu-page
  {
    margin-top: 10px !important;
    margin-bottom: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/TableSubjectToBeProcessed.vue